module.exports = require("isarray");


//////////////////
// WEBPACK FOOTER
// external "isarray"
// module id = 523
// module chunks = 0